/* $(document).ready(function(){
    initSwatches();
  $( ".dev-swatch" ).click(function() {
     initSwatches();
});
  
  
  $(document).ready(function(){
    var maxLength = 300;
    $(".show-read-more").each(function(){
        var myStr = $(this).html();
        if($.trim(myStr).length > maxLength){
            var newStr = myStr.substring(0, maxLength);
            var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
            $(this).empty().html(newStr);
          $(this).append(' <a href="javascript:void(0);" class="read-more" style="margin-left:5px;">  <strong>   Read More</strong></a>');
            $(this).append('<span class="more-text">' + removedStr + '</span>');
        }
    });
    $(".read-more").click(function(){
        $(this).siblings(".more-text").contents().unwrap();
        $(this).remove();
    });
});
  
  });

  
function initSwatches(){

    let selectedValue = $("input[type=radio]:checked.dev-swatch")[0].value;
    let thumbnails = $(".product-image-thumb");
    let product_name = $(".product_name").html();
    Array.from(thumbnails).forEach(function(thumbnail){
     
       if($(thumbnail.children).attr("alt") != product_name ){
      if(thumbnail.dataset.title == selectedValue){
        $(thumbnail).show();
      }
      else
      {
        
        $(thumbnail).hide();
      }
       }
    })
  }
  */




$(document).ready(function(){
    initSwatches();
    $(".dev-swatch").on("change", function() {
        initSwatches();
    });
});

  




  
function initSwatches(){
    // Gather all selected option values, excluding those inside quickshop forms containers
    let selectedValues = [];
    $("input[type=radio].dev-swatch:checked").each(function() {
        if (
            $(this).closest('.quickshop-forms__container').length === 0 &&
            $(this).closest('.js-quickshop-forms__container').length === 0 &&
            $(this).closest('.js-quickshop-forms--4446924177489').length === 0
        ) {
            selectedValues.push($(this).val());
        }
    });

    // Build a key, e.g., "Square Red"
    let selectedKey = selectedValues.join(' ');

    let thumbnails = $(".product-image-thumb");
    thumbnails.each(function() {
        let thumbKey = $(this).attr("data-title"); // e.g., "Square Red"
        if ((selectedKey.indexOf(thumbKey) !== -1) || thumbKey === "All") {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
}




$(document).ready(function(){
	var maxLength = 300;
    $(".show-read-more").each(function(){
        var myStr = $(this).html();
        var totallength=myStr.length;
        console.log('Total Length='+myStr.length);
        if($.trim(myStr).length > maxLength){
            var newStr = myStr.substring(0, maxLength);
          	if(newStr.substring(newStr.length-1,newStr.length)!=" "){
          	newStr=newStr.substring(0,newStr.lastIndexOf(' '));
          	}
          
            var removedStr = myStr.substring(newStr.length, totallength);
            $(this).empty().html(newStr);
          	$(this).append('<span class="dotdotdot">...</span><a href="javascript:void(0);" class="read-more" style="margin-left:5px;"><strong>Read More</strong></a>');
            $(this).append('<span class="more-text">' + removedStr + '</span>');
        }
    });
    
  	$(".read-more").click(function(){
        $(this).siblings(".more-text").contents().unwrap();
        $(this).remove();
        $('.dotdotdot').remove();
    });
});

/*
$('.linkcontent').each(function(index){
	
    html=$(this).html();
    s1=html.indexOf('https://');
    s0=html.substr(0,s1);
    s2=html.substr(s1,html.length);
    s3=s2.substr(0,s2.indexOf(' '));
    s4=s2.substr(s2.indexOf(' '),html.length);
    s5='';
    
  	if(s1<2){ 
    	s5=s5+'<a href="'+s3+'" class="button">'+'Download'+'</a>';
  	}
  	else{
    	s5=s5+(s0+'<br><a href="'+s3+'" class="button">'+'Download'+'</a>');
  	}
  
    if(s4.length>2){ 
		s5=s5+'<br>'+s4;
    }
  console.log("link:"+s5)
    //$(this).html(s5);
  
});*/

//if ($(this).hasClass('specifications', 'installation', 'productdimensions')) {

/*$('.specifications').each(function(index){
    
    html=$(this).html();
    s1=html.indexOf('https://');
    s0=html.substr(0,s1);
    s2=html.substr(s1,html.length);
    s3=s2.substr(0,s2.indexOf(' '));
    s4=s2.substr(s2.indexOf(' '),html.length);
    s5='';
    
  	if(s1<2){ 
    	s5=s5+'<a href="'+html+'" class="button">'+'Download'+'</a>';
  	}
  	else{
    	s5=s5+(s0+'<br><a href="'+html+'" class="button">'+'Download'+'</a>');
  	}
  
    if(s4.length>2){ 
		s5=s5+'<br>'+s4;
    }
  	
    $(this).html(s5);
    
});*/


$('.installation').each(function(index){
    
    html=$(this).html();
    s1=html.indexOf('https://');
    s0=html.substr(0,s1);
    s2=html.substr(s1,html.length);
    s3=s2.substr(0,s2.indexOf(' '));
    s4=s2.substr(s2.indexOf(' '),html.length);
    s5='';
    
  	if(s1<2){ 
    	s5=s5+'<a href="'+html+'" class="button">'+'Download'+'</a>';
  	}
  	else{
    	s5=s5+(s0+'<br><a href="'+html+'" class="button">'+'Download'+'</a>');
  	}
  
    if(s4.length>2){ 
		s5=s5+'<br>'+s4;
    }
  	
    $(this).html(s5);
    
});

 

$('.productdimensions').each(function(index){
    
    html=$(this).html();
    s1=html.indexOf('https://');
    s0=html.substr(0,s1);
    s2=html.substr(s1,html.length);
    s3=s2.substr(0,s2.indexOf(' '));
    s4=s2.substr(s2.indexOf(' '),html.length);
    s5='';
    
  	if(s1<2){ 
    	s5=s5+'<a href="'+html+'" class="button">'+'Download'+'</a>';
  	}
  	else{
    	s5=s5+(s0+'<br><a href="'+html+'" class="button">'+'Download'+'</a>');
  	}
  
    if(s4.length>2){ 
		s5=s5+'<br>'+s4;
    }
  	
    $(this).html(s5);
    
});





$('.partlist').each(function(index){
  
$('.partlist > p').contents().unwrap(); 
  
    html=$(this).html();
    
    s1=html.lastIndexOf('https://'); // value
  	s0=html.substr(0,s1); // start string
    s2=html.substr(s1,html.length); //link
   // s3=s2.substr(0,s2.indexOf(' '));
    //s4=s2.substr(s2.indexOf(' '),html.length);
    s5='';
    
  if(s0.length>2){
  	s5=(s0+'<br><a href="'+s2+'" class="button">'+'Download Part List'+'</a>');
  }
    else
    {
      s5=(s0+'<a href="'+s2+'" class="button">'+'Download Part List'+'</a>');
    }
  	
    $(this).html(s5);
    
});

 
 $('#panel-01 .specifications').each(function(index){ 
 
    html=$(this).html();
    //ss1=html.lastIndexOf('https://'); // start of the link zs5s

   /* 
   if(ss1){
        ss0=html.substr(0,ss1); // start string

        ss2=html.substr(ss1,html.length);
        sec = html.indexOf('</span>', ss1);
    
        download_link = html.substring(ss1, sec);
    
    
        console.log(ss1);
        console.log(sec);
        console.log(download_link);
    
        var final_str =  removeSubstring(html, ss1, sec);
        download_link  = '<a href="'+download_link+'" class="button">'+'Download'+'</a>';

        //final_str = final_str.replaceBetween(ss1, sec, download_link);
        
        final_str += download_link;
        
      console.log(final_str);
    
        $(this).html(final_str);
    }
    */
    
    ss1=html.lastIndexOf('https://'); // start of the link zs5s
  	ss0=html.substr(0,ss1); // start string
    ss2=html.substr(ss1,html.length); //link
    s3=ss2.substr(0,ss2.indexOf(' '));
    s4=ss2.substr(ss2.indexOf(' '),html.length);
    ss5='';
     
    if(ss0.length>2){
    	ss5=(ss0+'<a href="'+ss2+'" class="button">'+'Download'+'</a>');
    }
    else
    {
      ss5=(ss0+'<a href="'+ss2+'" class="button">'+'Download'+'</a>');
    }
    $(this).html(ss5);
    
});